export const SECTION_TITLE_PROMOTIONS_BY_CAR_MAKE = 'Promotions by Car Make';

export const PILL_ACTIVE_BACKGROUND_COLOR_RED_6 = 'red-1';
export const PILL_ACTIVE_TEXT_WEIGHT_REGULAR = 'regular';
export const PILL_BACKGROUND_COLOR_GRAY_1 = 'gray-1';
export const PILL_ACTIVE_BACKGROUND_COLOR_RED_1 = 'red-1';

export const READY_STOCKS_ICON_SIZE = 10;
